import breadcrumbs from './Database_breadcrumbs';
import classification from './Database_classification';
import oem from './Database_oem';
import product from './Database_product';
import glossary from './Database_glossary';
import modal from './Database_modal';
import api from '../../api/index';

export default {
  namespaced: true,
  modules   : {
    breadcrumbs,
    classification,
    oem,
    product,
    glossary,
    modal,
  },
  state: {
    current_tab   : 'classification',
    search        : '',
    search_results: {},
  },
  getters: {
    current_tab : ({current_tab}) => current_tab,
    current_list: function({current_tab}, {}, rootState) {
      if (current_tab=='oem') {
        return rootState.database.oem.content.list;
      } else if (current_tab=='products') {
        return rootState.database.product.content.list;
      } else if (current_tab=='glossary') {
        if (rootState.database.glossary.lang == 'ru') {
          return rootState.database.glossary.ru_filters;
        } else {
          return rootState.database.glossary.eng_filters;
        }
      } else {
        return rootState.database.classification.content.list;
      }
    },
    search        : ({search}) => search,
    search_results: ({search_results}) => search_results,
  },
  mutations: {
    SET_TAB(state, value) {
      state.current_tab = value;
    },
    SEARCH_DATABASE(state, value) {
      state.search = value;
    },
    SET_SEARCH_RESULTS(state, value) {
      state.search_results = value;
    },
  },
  actions: {
    async search_database({commit, getters}) {
      const {search} = getters;
      try {
        const get_search = await api.database.search_database(search);
        commit('SET_SEARCH_RESULTS', get_search.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
